import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseService } from "../shared/base.service";
import { environment } from "../../../environments/environment";

// Ya no se consulta directamente a Wompi desde el front

export interface PaymentMsStatusResponse {
  status: string;
}

@Injectable({
  providedIn: "root",
})
export class PaymentStatusService extends BaseService {
  private readonly msBaseUrl = environment.apiUrlMSPaymentService;

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Consulta el estado de una transacción en Wompi por su ID.
   * Nota: La ruta exacta del backend puede variar; ajusta si tu API difiere.
   */
  /**
   * Consulta el estado usando el MS de pagos, que retorna { status: string }
   */
  getMsStatusById(id: string): Observable<PaymentMsStatusResponse> {
    const url = `${this.msBaseUrl}/payments/wompi/status`;
    const params = new HttpParams().set('id', id);
    return this.http.get<PaymentMsStatusResponse>(url, { params });
  }

  // Sin fallback: toda consulta se hace al MS de pagos
}


